/**
 * @fileoverview Password-policy query hook.
 * @description Wraps GET /identity/password-policy so the set-password form's rule checklist
 * reads the platform's real complexity policy instead of a hardcoded copy.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { useQuery } from '@tanstack/react-query'

import { getPasswordPolicy } from '@/features/auth/services/password-policy.service'

/**
 * @description Fetches the platform's password complexity policy.
 * @returns {ReturnType<typeof useQuery>} The query object (data, isPending, isError, ...).
 */
export function usePasswordPolicy() {
  return useQuery({
    queryKey: ['identity', 'password-policy'],
    queryFn: getPasswordPolicy,
  })
}
